<template>
    <span class="badge-status rounded-3 m-1" :class="'order-status-' + status_id">{{ status_name }}</span>
</template>

<script>
import OrderStatus from '@/shared/models/enums/order-status'

export default {
    name: 'BadgeOrderStatusForDistributor',
    props: {
        status_id: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        status_name: function () {
            return OrderStatus.getForDistributor(this.status_id);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge-status {padding: .5rem 1rem; white-space: nowrap; line-height: 2.5rem;}
    .order-status-1 {background-color: rgb(220, 53, 69); color: #fff; border: 1px solid rgb(220, 53, 69)}
    .order-status-2 {background-color: rgb(61, 220, 53); border: 1px solid rgb(61, 220, 53)}
    .order-status-9 {background-color: rgb(103, 103, 103); color: #fff; border: 1px solid rgb(103, 103, 103)}
</style>
